<!-- template: reemplaza tu <DataTable> ... </DataTable> -->
<template>
  <LoadingSpinner v-if="listaCotizaciones.length === 0 || !user" />
  <div v-else class="py-4 container-fluid mt-4">
    <div class="card">
      <div class="card-body">
        <h6>Historial cotizaciones</h6>
        <vue-good-table
          ref="MyCoolTable"
          :columns="columns"
          :rows="listaCotizaciones"
          row-style-class="text-sm text-center"
          :search-options="{ enabled: true, placeholder: 'Buscar...' }"
          :pagination-options="{ enabled: true, perPage: 10 }"
          styleClass="vgt-table condensed bordered striped"
          :enable-row-expand="true"
          expanded-row-classes="bg-red"
          expanded-row-detail-classes="bg-yellow"
        >
          >
          <template #table-row="props">
            <span v-if="props.column.field == 'cliente'">
              <span class="text-md fw-bold">{{ props.row.cliente }}</span
              ><br />
              <span class="text-xxs text-secondary">{{
                props.row.atencion
              }}</span
              ><template v-if="user.es_lider || user.id == 9">
                <br />
                <span class="text-xxs text-secondary"
                  >Cotizó:
                  {{
                    capitalizarTexto(
                      `${props.row.usuario.nombre} ${props.row.usuario.paterno} ${props.row.usuario.materno}`
                    )
                  }}</span
                >
              </template>
            </span>
            <span v-if="props.column.field == 'arrendamiento'">
              <span class="text-md fw-bold">{{ props.row.arrendamiento }}</span
              ><br />
              <span class="text-xxs text-secondary">{{
                props.row.descripcion
              }}</span>
            </span>
            <span v-if="props.column.field == 'monto_financiado'">
              ${{ formatoMoneda(props.row.monto_financiado, false) }}
            </span>
            <span v-if="props.column.field == 'valor'">
              ${{ formatoMoneda(props.row.valor, false) }}
            </span>
            <span v-if="props.column.field == 'anticipo'">
              {{
                props.row.anticipo != 0
                  ? "$" + formatoMoneda(props.row.anticipo, false)
                  : "Sin anticipo"
              }}
            </span>
            <span v-if="props.column.field == 'porcentaje_tasa'">
              {{ formatoMoneda(props.row.porcentaje_tasa) }}%
            </span>
            <span v-if="props.column.field == 'seguro_financiado'">
              {{ props.row.seguro_financiado ? "Sí" : "No" }}<br />
              {{
                props.row.seguro != 0
                  ? "$" + formatoMoneda(props.row.seguro, false)
                  : ""
              }}
            </span>
            <span v-if="props.column.field == 'actions2'">
              <div
                class="d-flex justify-content-center align-items-center gap-2"
              >
                <router-link
                  :to="{
                    name: 'cotizacion-unidades-formato',
                    params: {
                      token: props.row.token,
                    },
                  }"
                >
                  <ArgonButton size="xs" color="light" icon="ri-file-line"
                    >Detalle</ArgonButton
                  >
                </router-link>
              </div>
            </span>
          </template>
          <template #row-details="props">
            <table
              class="table table-sm table-striped table-bordered"
              style="font-size: 13px"
            >
              <thead>
                <tr>
                  <th></th>
                  <th class="text-center">Plazo</th>
                  <th class="text-center">Residual</th>
                  <th class="text-center">Seguro mensual</th>
                  <th class="text-center">Renta</th>
                  <th class="text-center">Margen (%)</th>
                  <th class="text-center">Margen ($)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in props.row.children" :key="index">
                  <td>
                    <router-link
                      :to="{
                        name: 'cotizacion-unidades-editar',
                        params: {
                          token: props.row.token,
                        },
                        query: {
                          detalle_id: item.id,
                        },
                      }"
                    >
                      <ArgonButton
                        size="xs"
                        color="secondary"
                        icon="ri-file-copy-line"
                        >Duplicar</ArgonButton
                      >
                    </router-link>
                  </td>
                  <td class="text-center">{{ item.plazo }}</td>
                  <td class="text-center">
                    ${{ formatoMoneda(item.residual, false) }} ({{
                      item.residual_porcentaje
                    }}%)
                  </td>
                  <td class="text-center">
                    ${{ formatoMoneda(item.seguro_mensual, false) }}
                  </td>
                  <td class="text-center">
                    ${{ formatoMoneda(item.renta, false) }}
                  </td>
                  <td class="text-center">{{ item.margen_porcentaje }}%</td>
                  <td class="text-center">
                    ${{ formatoMoneda(item.margen_cantidad, false) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { VueGoodTable } from "vue-good-table-next";
import "vue-good-table-next/dist/vue-good-table-next.css";
import useUtil from "@/composables/useUtil";
import LoadingSpinner from "@/components/LoadingComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { useCotizacionUnidadHistorial } from "@/composables/useCotizacionUnidad";
import ArgonBadge from "@/components/ArgonBadge.vue";

const columns = [
  { label: "#", field: "id", sortable: true, tdClass: "text-center" },
  { label: "Cliente", field: "cliente" },
  { label: "Arrendamiento", field: "arrendamiento" },
  { label: "Valor", field: "valor", sortable: true, tdClass: "text-center" },
  { label: "Anticipo", field: "anticipo", tdClass: "text-center" },
  {
    label: "Monto financiado",
    field: "monto_financiado",
    tdClass: "text-center",
  },
  { label: "Tasa", field: "porcentaje_tasa", tdClass: "text-center" },
  {
    label: "Seguro financiado",
    field: "seguro_financiado",
    tdClass: "text-center",
  },
  // optionally add the usuario column conditionally in template
  {
    label: "",
    field: "actions2",
    sortable: false,
  },
];

const { formatoMoneda, capitalizarTexto } = useUtil();
const {
  get: getCotizaciones,
  listaCotizaciones,
  user,
} = useCotizacionUnidadHistorial();

const expandedRows = ref(new Set());

function toggleRow(id) {
  const set = new Set(expandedRows.value);
  if (set.has(id)) set.delete(id);
  else set.add(id);
  expandedRows.value = set;
}
function isExpanded(id) {
  return expandedRows.value.has(id);
}

onMounted(async () => {
  await getCotizaciones();
});
</script>
